import Vue from 'vue'

import router from '@/router'
import VueMeta from './plugin'

Vue.use(VueMeta, {
	router,
	appTitle: 'Studeo Hub',
})
